import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=eb1c9d26&"
import script from "./Page6.vue?vue&type=script&lang=js&"
export * from "./Page6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports